jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{ variant.id }}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });


      if (window.location.href.includes("https://www.wlabelstore.com/blogs/recetas/tagged/") ){
        const section = document.querySelector('#mainblog-sec');
        if (section) {
            section.scrollIntoView({ behavior: 'smooth' });
        }
    }
});
